import React from 'react';
import { Header } from 'layout';
import { UserTransactionsTable } from 'modules';
import { useGetIndependentIraUser } from 'hooks/api/independentIra';
import { useGetProfileTransactions } from 'hooks/api/portfolio';
import { USER_TYPE } from 'constants/userTypes';
import { USER_STATUS } from 'constants/status';
import { EntityStatus } from 'components/Label';
import StatusUserButton from 'components/StatusUserButton';
import EmptyPage from 'components/EmptyPage';
import GenerateAccountStatementButton from 'components/GenerateAccountStatementButton';
import IndependentIraNavTabs from '../components/IndependentIraNavTabs';
import IndependentIraBalance from '../components/IndependentIraBalance';
import IndependentIraActiveLimitOrders from '../components/IndependentIraActiveLimitOrders';

import styles from './IndependentIraTransactions.module.css';

const IndependentIraTransactions: React.FC = () => {
  const { data: independentIraUser } = useGetIndependentIraUser();
  const {
    data: transactionsData,
    isLoading: portfolioTransactionsLoading,
    isError,
    refetch,
    isRefetching,
    isSuccess,
  } = useGetProfileTransactions();

  return (
    <>
      <Header
        title={
          independentIraUser
            ? `${independentIraUser?.firstName} ${independentIraUser?.middleName ?? ''} ${
                independentIraUser?.lastName
              }`
            : ''
        }
        complexComponent={true}
        label={{
          status: independentIraUser?.profileStatus,
          entityStatus: EntityStatus.User,
          isAccountClosed: independentIraUser?.accountClosed,
        }}
      >
        {independentIraUser && (
          <StatusUserButton
            user={independentIraUser}
            userType={USER_TYPE.independentIra}
          />
        )}
        {independentIraUser?.profileStatus === USER_STATUS.active && (
          <GenerateAccountStatementButton user={independentIraUser} />
        )}
      </Header>

      <IndependentIraNavTabs />

      {independentIraUser?.profileStatus === USER_STATUS.active ? (
        <>
          <div className={styles.metricsWrapper}>
            <IndependentIraBalance />
            <IndependentIraActiveLimitOrders enableToFetch={isSuccess} />
          </div>
          <UserTransactionsTable
            transactionsData={transactionsData}
            portfolioTransactionsLoading={portfolioTransactionsLoading}
            isError={isError}
            isRefetching={isRefetching}
            refetch={refetch}
          />
        </>
      ) : (
        <EmptyPage />
      )}
    </>
  );
};

export default IndependentIraTransactions;
